var _indexOf = require('./_indexOf');


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_contains.js
 ** module id = 125
 ** module chunks = 0
 **/